/**
* @ComponentFor Avensia.Shop.Features.Shared.Blocks.VideoBlock.OldVideoBlock
*/
import React, { useEffect } from 'react';
import * as styles from './base.scss';
import { epiPropertyValue } from '@avensia/nitro5-scope-episerver';
import classnames from 'classnames';
function VideoBlock(props) {
    const getVideoUrl = (videoId, videoSource) => {
        if (videoSource === 'youTube') {
            return `//www.youtube.com/embed/${videoId}`;
        }
        else if (videoSource === 'vimeo') {
            return `//player.vimeo.com/video/${videoId}`;
        }
    };
    useEffect(() => {
        let reloadOTBanner = window['reloadOTBanner'];
        if (reloadOTBanner !== undefined) {
            reloadOTBanner();
        }
        else {
            console.log('Warning: reloadOTBanner does not exist in OneTrust-Script please add to startPage settings. Reload the page manually to show the video.');
        }
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.videoContainer },
            React.createElement("iframe", { src: window.location.hostname == 'localhost' && getVideoUrl(epiPropertyValue(props.videoId), epiPropertyValue(props.videoSource)), "data-src": getVideoUrl(epiPropertyValue(props.videoId), epiPropertyValue(props.videoSource)), className: classnames(styles.iframe, 'optanon-category-C0002-C0003-C0004'), frameBorder: "0", allowFullScreen: epiPropertyValue(props.allowFullscreen) }))));
}
export default VideoBlock;
